module.exports = __webpack_public_path__ + "static/media/active.2f89831d.svg";